import React from 'react';
import {
  RouteProps as ReactRouterProps,
  Route as ReactDOMRoute,
  Redirect,
} from 'react-router-dom';

import { useAuth } from '@hooks/auth';

interface RouteProps extends ReactRouterProps {
  isPrivate?: boolean;
  component?: React.ComponentType;
}

export const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { token, user } = useAuth();

  // console.log('>>> Route:user:', user, rest);

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        // console.log('>>> Route:isPrivate:', isPrivate, ' location:', location);
        return isPrivate === !!token && Component ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/admin/dashboard',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};
